import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _createSuper from "@babel/runtime-corejs2/helpers/esm/createSuper";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { ErrorTypes, LoginFlowInterface, StateTypes } from '@central-products/interface-login-flow';
import { SessionManagerStateType } from '@central-products/interface-session-manager';
import { LoginContainer } from './LoginContainer';
import './index.scss';
export var LoginFlow = /*#__PURE__*/function (_LoginFlowInterface) {
  _inherits(LoginFlow, _LoginFlowInterface);

  var _super = _createSuper(LoginFlow);

  function LoginFlow(config, dependencies) {
    var _this;

    _classCallCheck(this, LoginFlow);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "config", void 0);

    _defineProperty(_assertThisInitialized(_this), "dependencies", void 0);

    _defineProperty(_assertThisInitialized(_this), "state", StateTypes.NONE);

    _defineProperty(_assertThisInitialized(_this), "onStateChangedCallback", void 0);

    _defineProperty(_assertThisInitialized(_this), "domNode", null);

    _defineProperty(_assertThisInitialized(_this), "isUserLoggedIn", false);

    _this.config = config;
    _this.dependencies = dependencies;
    return _this;
  }

  _createClass(LoginFlow, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var _yield$this$dependenc, sessionState;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.dependencies['session-manager'].getState();

              case 2:
                _yield$this$dependenc = _context.sent;
                sessionState = _yield$this$dependenc.state;
                this.isUserLoggedIn = sessionState === SessionManagerStateType.LOGGED_IN;
                this.dependencies['session-manager'].onStateChanged(function (_ref) {
                  var state = _ref.state;
                  _this2.isUserLoggedIn = state === SessionManagerStateType.LOGGED_IN;

                  if (_this2.state === StateTypes.FORM_VISIBLE && _this2.isUserLoggedIn) {
                    _this2.cancel();
                  }
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _window$performance, _window$performance$m;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this.state !== StateTypes.NONE)) {
                  _context2.next = 2;
                  break;
                }

                throw {
                  error: ErrorTypes.INVALID_STATE
                };

              case 2:
                if (!this.isUserLoggedIn) {
                  _context2.next = 4;
                  break;
                }

                throw {
                  error: ErrorTypes.USER_ALREADY_LOGGED_IN
                };

              case 4:
                (_window$performance = window.performance) === null || _window$performance === void 0 ? void 0 : (_window$performance$m = _window$performance.mark) === null || _window$performance$m === void 0 ? void 0 : _window$performance$m.call(_window$performance, 'cp:login:start');
                this.render();
                this.setState(StateTypes.FORM_VISIBLE);
                return _context2.abrupt("return", {});

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function start() {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: "cancel",
    value: function () {
      var _cancel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(this.state === StateTypes.NONE || this.domNode === null)) {
                  _context3.next = 2;
                  break;
                }

                throw {
                  error: ErrorTypes.INVALID_STATE
                };

              case 2:
                ReactDOM.unmountComponentAtNode(this.domNode);
                document.body.removeChild(this.domNode);
                this.domNode = null;
                this.setState(StateTypes.NONE);
                return _context3.abrupt("return", {});

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function cancel() {
        return _cancel.apply(this, arguments);
      }

      return cancel;
    }()
  }, {
    key: "getState",
    value: function () {
      var _getState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", {
                  state: this.state
                });

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getState() {
        return _getState.apply(this, arguments);
      }

      return getState;
    }()
  }, {
    key: "onStateChanged",
    value: function onStateChanged(callback) {
      this.onStateChangedCallback = callback;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      this.domNode = document.createElement('div');
      document.body.appendChild(this.domNode);

      var onClose = function onClose() {
        _this3.cancel();
      };

      var onSubmit = function onSubmit() {
        var _window$performance2, _window$performance2$;

        (_window$performance2 = window.performance) === null || _window$performance2 === void 0 ? void 0 : (_window$performance2$ = _window$performance2.mark) === null || _window$performance2$ === void 0 ? void 0 : _window$performance2$.call(_window$performance2, 'cp:login:submit-start');

        _this3.setState(StateTypes.AWAIT_LOGIN);
      };

      var onSubmitFailed = function onSubmitFailed() {
        var _window$performance3, _window$performance3$;

        (_window$performance3 = window.performance) === null || _window$performance3 === void 0 ? void 0 : (_window$performance3$ = _window$performance3.mark) === null || _window$performance3$ === void 0 ? void 0 : _window$performance3$.call(_window$performance3, 'cp:login:submit-finish');

        _this3.setState(StateTypes.FORM_VISIBLE);
      };

      var onSubmitSuccess = function onSubmitSuccess() {
        var _window$performance4, _window$performance4$;

        (_window$performance4 = window.performance) === null || _window$performance4 === void 0 ? void 0 : (_window$performance4$ = _window$performance4.mark) === null || _window$performance4$ === void 0 ? void 0 : _window$performance4$.call(_window$performance4, 'cp:login:submit-finish');

        _this3.cancel();
      };

      var onActionRequested = function onActionRequested(eventId, context) {
        var isCloseRequired = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

        _this3.dependencies['account-actions'].execute({
          eventId: eventId,
          context: _Object$assign({}, context, {
            userFlow: 'login'
          })
        });

        if (isCloseRequired) {
          _this3.cancel();
        }
      };

      ReactDOM.render( /*#__PURE__*/React.createElement(LoginContainer, {
        environment: this.config.environment,
        jurisdiction: this.config.jurisdiction,
        locale: this.config.locale,
        enableSessionRenew: this.config.enableSessionRenew,
        dependencies: this.dependencies,
        onClose: onClose,
        onSubmit: onSubmit,
        onSubmitSuccess: onSubmitSuccess,
        onSubmitFailed: onSubmitFailed,
        onActionRequested: onActionRequested
      }), this.domNode);
    }
  }, {
    key: "setState",
    value: function setState(state) {
      if (this.state === state) {
        return;
      }

      this.state = state;

      if (this.onStateChangedCallback) {
        this.onStateChangedCallback({
          state: state
        });
      }
    }
  }]);

  return LoginFlow;
}(LoginFlowInterface);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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